import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import isNil from 'lodash.isnil';
import {
    TextCell,
    OFF_GRADE_ICON,
    getOffGradeText,
} from '../../../../components/cell/shared/Cells';
import { PERIOD, DATE_FORMAT } from '../../../../constants/shared/CommonConstants';
import { CELL_TYPE } from '../../../../constants/shared/CellConstants';
import { MEASURE } from '../../../../constants/shared/MeasuresConstants';
import { getGoalByMeasureGradePeriod } from '../../../../utils/shared/filterUtils';
import { getCursorPointerClassName } from '../../../../utils/shared/pmUtils';

const { BENCHMARK, STUDENT_SUMMARY } = CELL_TYPE;

const getForm = (measure, grade, period, formNumber, formGrade) => {
    const isPmPeriod = period === PERIOD.PM;
    const isOffGrade = grade !== formGrade;
    if (isPmPeriod && measure === MEASURE.TRC) return <></>;
    const formNumberText = isNil(formNumber) ? '' : `-${formNumber}`;
    if (isOffGrade)
        return (
            <>
                {`${getOffGradeText(formGrade)}${formNumberText}`}&nbsp;
                {OFF_GRADE_ICON}
            </>
        );
    return <>{`${period}${isPmPeriod ? formNumberText : ''}`}</>;
};
const MeasureRow = ({
    data,
    openProbeDetails,
    studentId,
    location,
    interps,
    className,
    CommonCellBuilder,
    isGoalAvailable,
    rowCellsDataTestId,
    getSpecificGoal,
    summerPeriodLabel,
}) => {
    const { measure, grade, formGrade, period, resultId, date, formNumber, probeMaxScore } = data;
    const isPmPeriod = period === PERIOD.PM;
    const goal = getGoalByMeasureGradePeriod(
        interps,
        measure,
        grade,
        period,
        getSpecificGoal(measure),
    );
    const isGoalAvailableFlag = isGoalAvailable(measure, grade, period);
    const isOffGrade = grade !== formGrade;

    const optionalPmCellClassNames =
        isPmPeriod || !isNil(probeMaxScore)
            ? `clear-cell-styles ${getCursorPointerClassName(resultId)}`
            : '';

    const optionalCellData = {
        goal,
        isGoalAvailable: isGoalAvailableFlag,
        maxScore: probeMaxScore,
        isMeasureAvailable: true,
        isAdditionalPanel: isNil(resultId),
        hasBottomSpace: false,
        classNames: `grid-cell grid-data-cell ${optionalPmCellClassNames}`,
    };

    return (
        <div className={className} data-test-id={rowCellsDataTestId}>
            <TextCell
                classNames="grid-cell first-cell"
                isDataCell={false}
                content={date ? format(new Date(date), DATE_FORMAT.FULL_DATE) : ''}
            />
            <TextCell
                classNames="grid-cell form-cell-width"
                isDataCell={false}
                content={getForm(
                    measure,
                    grade,
                    period === PERIOD.SUMMER ? summerPeriodLabel : period,
                    formNumber,
                    formGrade,
                )}
            />
            <CommonCellBuilder
                cellType={isPmPeriod ? BENCHMARK : STUDENT_SUMMARY}
                statusForMeasureYearPeriod={data}
                measure={measure}
                period={period}
                grade={grade}
                openPanel={resultId ? openProbeDetails : () => {}}
                externalId={studentId}
                location={location}
                gatingMeasureCellType={CELL_TYPE.SS_GATING_MEASURE}
                optionalCellData={optionalCellData}
                isCellDisabled={!isGoalAvailableFlag || isOffGrade}
            />
        </div>
    );
};

MeasureRow.defaultProps = {
    data: {},
    studentId: '',
    location: {},
    className: '',
    CommonCellBuilder: () => <></>,
    isGoalAvailable: () => {},
    rowCellsDataTestId: '',
    getSpecificGoal: () => '',
};

MeasureRow.propTypes = {
    data: PropTypes.object,
    interps: PropTypes.array.isRequired,
    openProbeDetails: PropTypes.func.isRequired,
    studentId: PropTypes.string,
    location: PropTypes.object,
    className: PropTypes.string,
    CommonCellBuilder: PropTypes.func,
    isGoalAvailable: PropTypes.func,
    getSpecificGoal: PropTypes.func,
    rowCellsDataTestId: PropTypes.string,
    summerPeriodLabel: PropTypes.string.isRequired,
};

export default MeasureRow;
